/**
 * Animated Number - Odometer Integration
 * Initializes odometer.js on all .odometer elements when they enter viewport
 */

(function() {
  'use strict';

  function initWhenReady() {
      const elements = document.querySelectorAll('.wp-block-a-animated-number .odometer, .a-animated-number .odometer');
      if (elements.length === 0) return;

      if (typeof Odometer === 'undefined') {
          setTimeout(initWhenReady, 100);
          return;
      }

      initOdometers();
  }

  function initOdometers() {
      const elements = document.querySelectorAll('.wp-block-a-animated-number .odometer, .a-animated-number .odometer');

      if (elements.length === 0) return;

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting && !entry.target.dataset.animated) {
                  const el = entry.target;

                  el.dataset.animated = 'true';

                  const targetNumber = parseInt(el.textContent.replace(/[^0-9]/g, ''), 10);

                  if (isNaN(targetNumber)) {
                      return;
                  }

                  el.innerHTML = '0';

                  const od = new Odometer({
                      el: el,
                      value: 0,
                      duration: 3000,
                      format: '(,ddd)'
                  });

                  setTimeout(() => {
                      od.update(targetNumber);
                  }, 150);

                  observer.unobserve(el);
              }
          });
      }, {
          threshold: 0.3,
          rootMargin: '0px'
      });

      elements.forEach(el => {
          observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
      initWhenReady();
  }

})();